import React from "react";
import { List } from "antd";
import {
    showTotalForTinyScreen,
    showTotalForLargeScreen,
} from "./ResponsiveTotals";
import "./SelectableList.less";
import useResponsiveScreen from "@Src/hooks/useResponsiveScreen";

const SelectableList = (props: any): React.JSX.Element => {
    const { itemList, itemListRenderItem } = props;
    const { isXxs, isXs, isMd } = useResponsiveScreen();

    return (
        <List
            className="item-issues__list"
            itemLayout="vertical"
            pagination={{
                showTotal: (total, range): React.ReactNode => {
                    if (isXxs || isXs) {
                        return showTotalForTinyScreen();
                    } else {
                        return showTotalForLargeScreen(total, range);
                    }
                },
                pageSize: 5,
                total: itemList.length,
                size: "small",
                showSizeChanger: false,
                responsive: true,
                simple: isXs || isXxs,
                showLessItems: !isMd,
            }}
            dataSource={itemList}
            renderItem={itemListRenderItem}
        />
    );
};

export default SelectableList;
